import {
  TReceivedInvoiceCondition,
  TSetupConditionProps,
} from '@/context/services/invoice/type';
import { useReceivedInvoiceUploadTypeOptions } from '@/features/invoices/hooks/useReceivedInvoiceUploadTypeOptions';
import { useRenewalUiReceivedInvoicesFlag } from '@/hooks/feature_flag/useRenewalUiReceivedInvoicesFlag';
import { useTranslation } from '@/i18n';
import { useGlobalContainerRef } from '@/wc/helper/ref';
import { FormSelect, SelectProps } from '@moneyforward/ap-frontend-components';
import { FC, memo, useMemo } from 'react';

export const UploadType: FC<TSetupConditionProps> = memo(
  ({ control, name }) => {
    const { t } = useTranslation();
    const flagRenewalUiReceivedInvoices = useRenewalUiReceivedInvoicesFlag();
    const getPopupContainer = useGlobalContainerRef();
    const options = useReceivedInvoiceUploadTypeOptions();
    const selectProps: SelectProps = useMemo(
      () => ({
        options: options,
        mode: 'multiple',
        selectAll: true,
        maxTagCount: 1,
        ...(flagRenewalUiReceivedInvoices ? { getPopupContainer } : {}),
      }),
      [options, flagRenewalUiReceivedInvoices, getPopupContainer]
    );
    const labelProps = useMemo(
      () => ({
        text: t('label_upload_type'),
      }),
      [t]
    );

    return (
      <FormSelect<TReceivedInvoiceCondition>
        control={control}
        name={name}
        selectProps={selectProps}
        label={labelProps}
        inputId='invoice-search-upload-type'
        testId='invoice-search-upload-type'
      />
    );
  }
);
UploadType.displayName = 'UploadType';
